var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthsun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "23px",
    viewBox: "0 0 25 23",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "auth-sun",
    transform: "translate(3.000000, 3.000000)",
    stroke: "#2E2B63"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-20",
    strokeLinecap: "round",
    points: "7.5486802 3 8.7787665 0 9.9158494 3"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-20-Copy",
    strokeLinecap: "round",
    transform: "translate(8.732265, 15.500000) rotate(-180.000000) translate(-8.732265, -15.500000) ",
    points: "7.5486806 17 8.7787669 14 9.9158498 17"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-20-Copy-2",
    strokeLinecap: "round",
    transform: "translate(2.000000, 9.000000) rotate(-90.000000) translate(-2.000000, -9.000000) ",
    points: "1 10.2677352 2.03928891 7.7322648 3 10.2677352"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-20-Copy-3",
    strokeLinecap: "round",
    transform: "translate(16.891033, 8.693712) rotate(90.000000) translate(-16.891033, -8.693712) ",
    points: "15.8910327 9.9614472 16.9303216 7.4259768 17.8910327 9.9614472"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-20",
    strokeLinecap: "round",
    transform: "translate(14.074035, 3.381974) rotate(45.000000) translate(-14.074035, -3.381974) ",
    points: "12.8904508 4.88197418 14.1205372 1.88197418 15.25762 4.88197418"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-20-Copy",
    strokeLinecap: "round",
    transform: "translate(4.174540, 13.281469) rotate(-135.000000) translate(-4.174540, -13.281469) ",
    points: "2.99095491 14.7814688 4.22104127 11.7814688 5.35812414 14.7814688"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-20-Copy-2",
    strokeLinecap: "round",
    transform: "translate(4.010304, 3.924844) rotate(-45.000000) translate(-4.010304, -3.924844) ",
    points: "3.01030408 5.19257964 4.04959299 2.65710918 5.01030408 5.19257964"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-20-Copy-3",
    strokeLinecap: "round",
    transform: "translate(14.499848, 13.992669) rotate(135.000000) translate(-14.499848, -13.992669) ",
    points: "13.4998482 15.2604041 14.5391371 12.7249337 15.4998482 15.2604041"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9.5,
    cy: 8.5,
    r: 4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthsun);
export default __webpack_public_path__ + "static/media/authsun.b072ddbd19154e0f8a8b127f1ea89d2f.svg";
export { ForwardRef as ReactComponent };